const phaseGridConfig: any = {
  defaultSort: [{ field: 'number', dir: 'asc' }],
  columns:
    [
      {
        field: 'number',
        title: 'Phase No.',
        filter: 'numeric',
        _width: 80
      },
      {
        field: 'name',
        title: 'Phase Name',
        filter: 'text',
        _width: 180
      },
      {
        field: 'description',
        title: 'Description',
        filter: 'text',
        _width: 210
      },
      {
        field: 'stageCount',
        title: 'Stages',
        filter: 'numeric',
        _width: 70,
        clickable: true
      },
      {
        field: '_actions',
        title: 'Actions',
        filter: null,
        _width: 100,
      }
    ]
};

export default phaseGridConfig;



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-phase-grid/project-detail-phase-grid.config.ts